import { Spin } from 'antd';
import { useEffect } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { connect } from 'react-redux';

import { TComma, formatNumberWithCurrency } from '../../../../base/utils';
import { Page, Uniter } from '../../../../helbest';
import { API } from '../../../../request/api';
import { _set_i_user } from '../../../../store/actions/login_actions';
import { ReactComponent as EmptyBoxIcon } from './../../../../assets/svg/empty-box.svg';
import { ReactComponent as WalletIcon } from './../../../../assets/svg/footer-wallet.svg';
import styles from './../Profile.module.css';
import CreditFilterSort from './CreditFilterSort/CreditFilterSort';
import useFilter from './CreditFilterSort/useFilter';

export const sort_list = [
  { label: 'جدید‌ترین‌ها', value: 1, key: '-created_at' },
  { label: 'قیمت صعودی', value: 2, key: 'amount' },
  { label: 'قیمت نزولی', value: 3, key: '-amount' }
];

export const types_list = [
  { label: 'همه', key: 'all', value: 1 },
  { label: 'افزایش', key: 'increase', value: 2 },
  { label: 'کاهش', key: 'decrease', value: 3 }
];

const Credit = ({ Login, setIUser, history }) => {
  const [
    type,
    set_type,
    price_from,
    set_price_from,
    price_to,
    set_price_to,
    date_from,
    set_date_from,
    date_to,
    set_date_to,
    sort_visible,
    set_sort_visible,
    sort_value,
    set_sort_value,
    filtered_list,
    submit_filter,
    next,
    loading
  ] = useFilter();

  const getUserData = () => {
    API.get
      .editProfile()
      .then((response) => {
        if (response.success) {
          setIUser({
            phone_number: response.data.username,
            token: response.data.token,
            first_name: response.data.first_name,
            last_name: response.data.last_name,
            credit: response.data.credit
          });
        }
        return response;
      })
      .catch((error) => {
        console.error('Error : ', error);
      });
  };

  useEffect(() => {
    if (!Login.is_login) {
      history.push('/login/d/');
      return;
    }
    getUserData();
  }, []); // eslint-disable-line

  return (
    <Page
      address="/profile/"
      back={true}
      className="page-profile credit-page"
      goback
      headerFix
      logo
      mobileContainer
      showFooter
      title="تراکنش‌های اعتبار">
      <div className="container desktop-mode credit-scroller">
        <div>
          <div className="credit-header">
            <div className="credit-money-container">
              <WalletIcon className="wallet-icon" />
              <span className="mar-l-10">اعتبار من:</span>
              {formatNumberWithCurrency(TComma(Login.credit))}
            </div>

            <CreditFilterSort
              date_from={date_from}
              date_to={date_to}
              price_from={price_from}
              price_to={price_to}
              set_date_from={set_date_from}
              set_date_to={set_date_to}
              set_price_from={set_price_from}
              set_price_to={set_price_to}
              set_sort_value={set_sort_value}
              set_sort_visible={set_sort_visible}
              set_type={set_type}
              sort_value={sort_value}
              sort_visible={sort_visible}
              submit_filter={submit_filter}
              type={type}
            />
          </div>
          <InfiniteScroll
            hasMore={next !== null}
            loader={
              <div className="credit-page-loading-container">
                <Spin className="red" />
              </div>
            }
            loadMore={() => {
              if (next) {
                submit_filter(true);
              }
            }}
            pageStart={1}>
            {!!filtered_list && filtered_list.length === 0 && !loading ? (
              <div className={styles.EmptyContainer}>
                <EmptyBoxIcon className={styles.EmptyBoxIcon} />
                <div className={styles.EmptyText}>تراکنشی وجود ندارد</div>
              </div>
            ) : null}
            {filtered_list.map((x, i) => (
              <div
                key={i}
                className={`flex-r animated fadeIn credit-box mar-10 ${
                  x.state === 'increase' ? 'credit-box-green' : 'credit-box-red'
                }`}>
                <p>{x.title}</p>
                <div className="flex-r mar-t-5 flex-between">
                  <p className="text-black">{x.date}</p>
                  <div className="flex-r text-black">
                    {/* <Uniter className="" unit="تومان">
                      {x.amount}
                    </Uniter> */}
                    {formatNumberWithCurrency(TComma(x.amount))}
                  </div>
                </div>
              </div>
            ))}
          </InfiniteScroll>
        </div>
      </div>
    </Page>
  );
};

const mapStateToProps = (state) => ({
  Login: state.Login
});

const mapDispatchToProps = (dispatch) => ({
  setIUser: (user) => dispatch(_set_i_user(user))
});

export default connect(mapStateToProps, mapDispatchToProps)(Credit);
